// Module
var code = "<survey-viewer></survey-viewer>";
// Exports
module.exports = code;